import React, { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader, EmptyState, Loader, StatusBadge } from "@/components/dashboard/ui";

export default function SecretaryMissions() {
  const [missions, setMissions] = useState(null);
  const load = () => api.get("/missions").then(({ data }) => setMissions(data || []));
  useEffect(() => { load(); }, []);
  const act = async (m, status) => {
    try { await api.put(`/missions/${m.mission_id}`, { status }); toast.success("Mise à jour"); load(); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (missions === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Mes missions" subtitle="Toutes vos missions attribuées, confirmées et terminées." />
      {missions.length === 0 ? <EmptyState icon={CalendarCheck} title="Aucune mission" /> : (
        <div className="space-y-3">{missions.map((m) => (
          <div key={m.mission_id} className="bg-white rounded-xl border border-slate-200 p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`sec-mission-${m.mission_id}`}>
            <div><p className="font-medium text-slate-900">{new Date(m.date).toLocaleDateString("fr-CH", { weekday: "long", day: "numeric", month: "long" })} · {m.start}–{m.end}</p><p className="text-sm text-slate-500">{m.client_name} · {(m.services || []).join(", ")}</p></div>
            <div className="flex items-center gap-2">
              <StatusBadge status={m.status} />
              {m.status === "Attribuée" && <><Button size="sm" className="bg-primary" onClick={() => act(m, "Confirmée")}>Accepter</Button><Button size="sm" variant="outline" className="text-rose-600" onClick={() => act(m, "Annulée")}>Refuser</Button></>}
              {["Confirmée", "En cours"].includes(m.status) && <Button size="sm" variant="outline" onClick={() => act(m, "Terminée")}>Terminer</Button>}
            </div>
          </div>))}
        </div>
      )}
    </div>
  );
}
